<template>
  <div class="my-list">
    <div class="tabs">
      <div :class="'tab-item '+(status===''?'tab-item-active':'')" @click="changeStatus('')">全部</div>
      <div :class="'tab-item '+(status==='1'?'tab-item-active':'')"  @click="changeStatus('1')">发布成功</div>
      <div :class="'tab-item '+(status==='0'?'tab-item-active':'')"  @click="changeStatus('0')">审核中</div>
      <div :class="'tab-item '+(status==='2'?'tab-item-active':'')"  @click="changeStatus('2')">审核失败</div>
    </div>
    <div class="post-list" v-if="dataList&&dataList.length">
      <div class="post-info" v-for="item in dataList" :key="item.id">
        <div class="post-info-img" @click="routerHandle(item)">
          <img :src="item.userAvatarURL" width="74px" height="74px" :alt="item.title"/>
        </div>
        <div class="post-detail" @click="routerHandle(item)">
          <div class="post-detail-title overell">{{item.title}}</div>
          <div class="post-detail-content">{{item.evaluate}}</div>
          <div class="post-detail-time">
            <span>评论时间：{{item.createTime}}</span>
          </div>
        </div>
        <div class="post-status">
          <div v-if="item.status===1" class="post-status-success">评论成功</div>
          <div v-else-if="item.status===0" class="post-status-ing">评论提交，审核中<br/>请耐心等待......</div>
          <div v-else class="post-status-fail">评论失败</div>
          <div v-if="item.status!==1" class="post-status-success-del" @click.stop="deleteHandle(item)">删除</div>
        </div>
      </div>
    </div>
    <div v-else>
      <div style="text-align:center">
        <img :src="BASE_URL + 'img/kong.png'" alt="暂无数据">
      </div>
    </div>
    <div class="doclist-pagination" v-if="dataList&&dataList.length">
      <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
      <div class="doclist-omit">{{lastOmit}}</div>
      <ul>
        <li :class="item === currentPage?'pageactive':''" v-for="item in pageList" :key="item" @click="changePageTo(item)">{{item}}</li>
      </ul>
      <div class="doclist-omit">{{nextOmit}}</div>
      <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
      <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
      <div class="doclist-jump" @click="jumpFarPage">确定</div>
    </div>
  </div>
</template>

<script>
import { track } from '@/utils/knowledgeEventTracking'
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      status: '',
      dataList: [],
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1 // 跳转页
    }
  },
  computed: {
    // 计算属性的 getter
  },
  mounted () {
    this.getDataList(this.currentPage)
  },
  methods: {
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      this.getDataList(page)
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.changePageTo(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    init () {
      this.$nextTick(() => {
        this.getDataList(1)
        // this.dataForm.companyId = ''
      })
    },
    getDataList (currentPage = this.currentPage) {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/userevaluateinfo/myEvaluate`, {
        'page': currentPage,
        'limit': 10,
        'status': this.status === '' ? null : this.status
      })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.dataList = data.data.data || []
            this.totalPage = Math.ceil(Number(data.data.count) / 10)
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.setPageTo(currentPage)
        })
        .catch(() => {
          this.dataList = []
          this.totalPage = 0
          this.setPageTo(currentPage)
        })
    },
    setPageTo (page) {
      if (this.totalPage === 0) {
        this.pageList = []
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = 0
        return
      } else if (page > this.totalPage) {
        this[this.status](this.totalPage)
        return
      }
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    changeStatus (index) {
      this.status = index
      this.getDataList(1)
    },
    routerHandle (item) {
      if (item.evaluateType === 'VIDEO') {
        track.clickVideoDetail(item.videoTitle)
        this.$router.push({
          name: 'knowledgevideoDetil',
          query: {
            videoId: item.evaluateDataId
          }
        })
      } else if (item.evaluateType === 'POST') {
        this.$router.push({
          name: 'postsDetail',
          query: {
            id: item.evaluateDataId
          }
        })
      } else if (item.evaluateType === 'FILE') {
        track.clickDocDetail(item.fileTitle)
        this.$router.push({
          name: 'bookDocDetail',
          query: {
            fileId: item.evaluateDataId
          }
        })
      }
    },
    // 删除非审核通过的数据
    deleteHandle (item) {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/userevaluateinfo/deleteMyEvaluate`, {
        id: item.id,
        evaluateType: item.evaluateType
      })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.$message.success('删除成功')
            this.dataList = []
            this.totalPage = 0
            this.getDataList()
          } else {
          }
        })
        .catch(() => {
          // console.log(err.message)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.my-list{
  margin: 0 79px;
}
.post-info{
  margin-top: 30px;
  width: 100%;
  display: flex;
  padding-bottom: 28px;
  border-bottom: 1px solid #eee;
}
.post-info-img{
  width: 74px;
  height: 74p;
  cursor: pointer;
}
.post-info-img img{
  width: 74px;
  height: 74p;
  border-radius: 37px;
  overflow: hidden;
}
.post-detail {
  cursor: pointer;
  width: 550px;
  margin-right: 20px;
  margin-left: 30px;
}
.post-detail-title{
  text-align: left;
  line-height: 22px;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0.6px;
  height: 22px;
  margin-bottom: 10px;
}
.post-detail-content{
  width: 450px;
  text-align: left;
  line-height: 20px;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.6px;
  height: 20px;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.post-detail-time{
  line-height: 17px;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0.6px;
}
.post-status{
    width: 120px;
    text-align: center;
}
.post-status-success{
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  color: #1D65A8;
  height: 20px;
}
.post-status-ing{
  text-align: left;
  line-height: 20px;
  font-size: 14px;
  color: #E2980A;
  width: 120px;
}
.post-status-fail{
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  color: #BF1B22;
  height: 20px;
}
.post-status-success-del{
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  color: #1D65A8;
  height: 20px;
  cursor: pointer;
}
.tab-item-active {
  color: #1D65A8;
  border-bottom: 2px solid #1D65A8;
}
.tab-item {
  display: inline-block;
  /* padding: 12px 16px; */
  text-align: center;
  background: #FFFFFF;
  /* box-shadow: inset 0 -1px 0 0 #dddddd; */
  /* width: 88px; */
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  letter-spacing: 0;
  margin-right: 24px;
  cursor: pointer;
}
</style>
